import { createAnimation, Animation } from '@ionic/react'
import { isRTL } from 'mobile_web/modules/platform'

export const popoverEnterAnimation = (baseEl: HTMLElement): Animation => {
	const root = baseEl.shadowRoot ?? baseEl

	const backdropAnimation = createAnimation()
		.addElement(root.querySelector('ion-backdrop')!)
		.fromTo('opacity', 0.01, 'var(--backdrop-opacity)')
		.beforeStyles({
			'pointer-events': 'none',
		})
		.afterClearStyles(['pointer-events'])

	const wrapperAnimation = createAnimation().addElement(root.querySelector('.popover-wrapper')!).beforeStyles({
		opacity: 1,
	})

	const contentAnimation = createAnimation().addElement(root.querySelector('.popover-content')!)

	if (isRTL()) contentAnimation.fromTo('transform', 'translateX(0%)', 'translateX(100%)')
	else contentAnimation.fromTo('transform', 'translateX(100%)', 'translateX(0%)')

	return createAnimation()
		.easing('ease-out')
		.duration(300)
		.addAnimation([backdropAnimation, wrapperAnimation, contentAnimation])
}

export const popoverLeaveAnimation = (baseEl: HTMLElement): Animation => {
	const root = baseEl.shadowRoot ?? baseEl

	const backdropAnimation = createAnimation()
		.addElement(root.querySelector('ion-backdrop')!)
		.fromTo('opacity', 'var(--backdrop-opacity)', 0)
		.beforeStyles({
			'pointer-events': 'none',
		})
		.afterClearStyles(['pointer-events'])

	const wrapperAnimation = createAnimation().addElement(root.querySelector('.popover-wrapper')!).beforeStyles({
		opacity: 1,
	})

	const contentAnimation = createAnimation().addElement(root.querySelector('.popover-content')!)

	if (isRTL()) contentAnimation.fromTo('transform', 'translateX(100%)', 'translateX(0%)')
	else contentAnimation.fromTo('transform', 'translateX(0%)', 'translateX(100%)')

	const baseAnimation = createAnimation()
		.addElement(baseEl)
		.easing('ease-out')
		.duration(300)
		.addAnimation([backdropAnimation, wrapperAnimation, contentAnimation])

	return baseAnimation
}
